import { Download } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateTable from 'src/components/ui-component/form-component/create-form/CreateTable';
import { NonRequired } from 'src/lib/validation/ValidationTypes';
import { InhaltTrenner } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { DownloadDeMinimis } from '../../../../DownloadAntragPDF';
import PostVersandInfoDeminimis from './PostVersandInfoDeminimis';

// import schemas
import { getAntragstellerName } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import Schema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const DateienMinimisGlobal: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	const handleDownloadDeMinimis = () => {
		DownloadDeMinimis(application, readOnly, saveApplication);
	};
	return (
		<>
			<Box>
				<Stack spacing={3} sx={{ width: '100%', mt: '1rem' }}>
					<Typography variant='h5' component={'p'} sx={{ fontWeight: 600 }}>
						Download der De-minimis-Selbsterklärung
					</Typography>
					<Typography>Bitte laden Sie hier Ihre vollständig ausgefüllte De-minimis-Selbsterklärung zur Unterzeichnung herunter:</Typography>
					<Button variant='outlined' startIcon={<Download />} onClick={() => handleDownloadDeMinimis()} sx={{ maxWidth: 'fit-content' }}>
						De-minimis-Selbsterklärung für {getAntragstellerName(application)} herunterladen
					</Button>
					<Typography>
						<strong>Bitte beachten Sie:</strong> Die Unterzeichnung der De-minimis-Selbsterklärung muss per eigenhändiger Unterschrift erfolgen.
						Das Einfügen einer Bilddatei o.Ä. als Unterschrift ist nicht zulässig. Bitte speichern Sie die unterzeichnete Erklärung anschließend
						als pdf- Datei ab.
					</Typography>
				</Stack>

				<Stack spacing={3} sx={{ width: '100%', mt: '1rem' }}>
					<InhaltTrenner />
					<Typography variant='h5' component={'p'} sx={{ fontWeight: 600 }}>
						Upload der De-minimis-Selbsterklärung
					</Typography>
					<Typography>Bitte laden Sie hier die unterzeichnete De-minimis-Selbsterklärung als pdf-Datei hoch:</Typography>
					<CreateTable
						formStruc={formStrucDatein()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
						columnsLabel={['Bezeichnungs des Dokuments', 'Datei']}
					/>
					<Typography>
						<strong>Wichtig:</strong> Die unterzeichnete De-minimis-Selbsterklärung ist Bestandteil des Förderantrags. Der Upload der Erklärung
						an dieser Stelle ist daher wichtig für die Einreichung Ihres vollständigen Antrags auf Förderung.
					</Typography>
				</Stack>

				<PostVersandInfoDeminimis application={application} />
			</Box>
		</>
	);
};

export default DateienMinimisGlobal;

const formStrucDatein = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ path: 't.t', type: 'label', label: 'De-minimis-Selbsterklärung', validation: [{ validateFunction: NonRequired }] },
				{ ...P.Deminimis_Unterschriebene_Erklaerung, hideLabel: true, allowedFileNameKeywords: ['De-minimis-Erklaerung'] },
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];

	return struc;
};

export const getFormStrucDateienMinimis = () => {
	return concat(formStrucDatein());
};
